import request from "./request";

export const getPickupBlocks = (query) =>
  request({ url: `/pickupBlocks`, params: query });

export const getPickupBlock = (id) => request({ url: `/pickupBlocks/${id}` });
